import { ContainerTypeEnum, Currency, ExtractedFirmQuoteDTO, Incoterms } from 'api';
import { translate } from 'i18n';
import { DataGridColumn } from 'ui';

export const columns: DataGridColumn<ExtractedFirmQuoteDTO>[] = [
  {
    columnSize: 'large',
    editable: true,
    field: 'origin_name',
    headerName: translate('backlog.firmQuoteBulkForm.columns.originName', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.origin?.name || '',
    valueSetter: (value, row) => {
      const newRow = { ...row };
      if (!newRow.origin) {
        newRow.origin = { country: '', lat: 0, lon: 0, name: '' };
      }
      newRow.origin = { ...newRow.origin, name: value };
      return newRow;
    },
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'origin_country',
    headerName: translate('backlog.firmQuoteBulkForm.columns.originCountry', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.origin?.country || '',
    valueSetter: (value, row) => {
      const newRow = { ...row };
      if (!newRow.origin) {
        newRow.origin = { country: '', lat: 0, lon: 0, name: '' };
      }
      newRow.origin = { ...newRow.origin, country: value };
      return newRow;
    },
  },
  {
    columnSize: 'small',
    editable: true,
    field: 'origin_lat',
    headerName: translate('backlog.firmQuoteBulkForm.columns.originLat', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) => row?.origin?.lat || 0,
    valueSetter: (value, row) => {
      const newRow = { ...row };
      if (!newRow.origin) {
        newRow.origin = { country: '', lat: 0, lon: 0, name: '' };
      }
      newRow.origin = { ...newRow.origin, lat: value };
      return newRow;
    },
  },
  {
    columnSize: 'small',
    editable: true,
    field: 'origin_lon',
    headerName: translate('backlog.firmQuoteBulkForm.columns.originLon', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) => row?.origin?.lon || 0,
    valueSetter: (value, row) => {
      const newRow = { ...row };
      if (!newRow.origin) {
        newRow.origin = { country: '', lat: 0, lon: 0, name: '' };
      }
      newRow.origin = { ...newRow.origin, lon: value };
      return newRow;
    },
  },
  {
    columnSize: 'small',
    editable: true,
    field: 'port_of_loading_unloc',
    headerName: translate('backlog.firmQuoteBulkForm.columns.portOfLoading', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.port_of_loading_unloc || '',
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'destination_name',
    headerName: translate('backlog.firmQuoteBulkForm.columns.destinationName', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.destination?.name || '',
    valueSetter: (value, row) => {
      const newRow = { ...row };
      if (!newRow.destination) {
        newRow.destination = { country: '', lat: 0, lon: 0, name: '' };
      }
      newRow.destination = { ...newRow.destination, name: value };
      return newRow;
    },
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'destination_country',
    headerName: translate('backlog.firmQuoteBulkForm.columns.destinationCountry', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.destination?.country || '',
    valueSetter: (value, row) => {
      const newRow = { ...row };
      if (!newRow.destination) {
        newRow.destination = { country: '', lat: 0, lon: 0, name: '' };
      }
      newRow.destination = { ...newRow.destination, country: value };
      return newRow;
    },
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'destination_lat',
    headerName: translate('backlog.firmQuoteBulkForm.columns.destinationLat', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) => row?.destination?.lat || 0,
    valueSetter: (value, row) => {
      const newRow = { ...row };
      if (!newRow.destination) {
        newRow.destination = { country: '', lat: 0, lon: 0, name: '' };
      }
      newRow.destination = { ...newRow.destination, lat: value };
      return newRow;
    },
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'destination_lon',
    headerName: translate('backlog.firmQuoteBulkForm.columns.destinationLon', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) => row?.destination?.lon || 0,
    valueSetter: (value, row) => {
      const newRow = { ...row };
      if (!newRow.destination) {
        newRow.destination = { country: '', lat: 0, lon: 0, name: '' };
      }
      newRow.destination = { ...newRow.destination, lon: value };
      return newRow;
    },
  },
  {
    columnSize: 'small',
    editable: true,
    field: 'port_of_discharge_unloc',
    headerName: translate('backlog.firmQuoteBulkForm.columns.portOfDischarge', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.port_of_discharge_unloc || '',
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'supply_incoterm',
    headerName: translate('backlog.firmQuoteBulkForm.columns.supplyIncoterm', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.supply_incoterm || '',
    valueOptions: Object.values(Incoterms) as string[],
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'demand_incoterm',
    headerName: translate('backlog.firmQuoteBulkForm.columns.demandIncoterm', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.demand_incoterm || '',
    valueOptions: Object.values(Incoterms) as string[],
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'e2e_currency',
    headerName: translate('backlog.firmQuoteBulkForm.columns.e2eCurrency', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.e2e_currency || '',
    valueOptions: Object.values(Currency) as string[],
  },
  {
    columnSize: 'small',
    editable: true,
    field: 'e2e_cost',
    headerName: translate('backlog.firmQuoteBulkForm.columns.e2eCost', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) => (row?.e2e_cost ? parseFloat(row.e2e_cost as string) || 0 : 0),
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'ocean_freight_currency',
    headerName: translate('backlog.firmQuoteBulkForm.columns.oceanFreightCurrency', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.ocean_freight_currency || '',
    valueOptions: Object.values(Currency) as string[],
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'ocean_freight_cost',
    headerName: translate('backlog.firmQuoteBulkForm.columns.oceanFreightCost', { namespace: 'features' }),
    valueGetter: (_value, row) => (row?.ocean_freight_cost ? parseFloat(row.ocean_freight_cost as string) || 0 : 0),
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'carrier',
    headerName: translate('backlog.firmQuoteBulkForm.columns.carrier', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.carrier || '',
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'pre_carriage_currency',
    headerName: translate('backlog.firmQuoteBulkForm.columns.preCarriageCurrency', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.pre_carriage_currency || '',
    valueOptions: Object.values(Currency) as string[],
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'pre_carriage_cost',
    headerName: translate('backlog.firmQuoteBulkForm.columns.preCarriageCost', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) => (row?.pre_carriage_cost ? parseFloat(row.pre_carriage_cost as string) || 0 : 0),
  },
  {
    columnSize: 'xLarge',
    editable: true,
    field: 'bunker_adjustment_factor_currency',
    headerName: translate('backlog.firmQuoteBulkForm.columns.bunkerAdjustmentFactorCurrency', {
      namespace: 'features',
    }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.bunker_adjustment_factor_currency || '',
    valueOptions: Object.values(Currency) as string[],
  },
  {
    columnSize: 'xLarge',
    editable: true,
    field: 'bunker_adjustment_factor_cost',
    headerName: translate('backlog.firmQuoteBulkForm.columns.bunkerAdjustmentFactorCost', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) =>
      row?.bunker_adjustment_factor_cost ? parseFloat(row.bunker_adjustment_factor_cost as string) || 0 : 0,
  },
  {
    columnSize: 'xLarge',
    editable: true,
    field: 'peak_season_surcharge_currency',
    headerName: translate('backlog.firmQuoteBulkForm.columns.peakSeasonSurchargeCurrency', {
      namespace: 'features',
    }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.peak_season_surcharge_currency || '',
    valueOptions: Object.values(Currency) as string[],
  },
  {
    columnSize: 'xLarge',
    editable: true,
    field: 'peak_season_surcharge_cost',
    headerName: translate('backlog.firmQuoteBulkForm.columns.peakSeasonSurchargeCost', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) =>
      row?.peak_season_surcharge_cost ? parseFloat(row.peak_season_surcharge_cost as string) || 0 : 0,
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'on_carriage_currency',
    headerName: translate('backlog.firmQuoteBulkForm.columns.onCarriageCurrency', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.on_carriage_currency || '',
    valueOptions: Object.values(Currency) as string[],
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'on_carriage_cost',
    headerName: translate('backlog.firmQuoteBulkForm.columns.onCarriageCost', { namespace: 'features' }),
    type: 'number',
    valueGetter: (_value, row) => (row?.on_carriage_cost ? parseFloat(row.on_carriage_cost as string) || 0 : 0),
  },
  {
    columnSize: 'large',
    editable: true,
    field: 'direct_land_currency',
    headerName: translate('backlog.firmQuoteBulkForm.columns.directLandCurrency', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.direct_land_currency || '',
    valueOptions: Object.values(Currency) as string[],
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'direct_land_cost',
    headerName: translate('backlog.firmQuoteBulkForm.columns.directLandCost', { namespace: 'features' }),
    valueGetter: (_value, row) => (row?.direct_land_cost ? parseFloat(row.direct_land_cost as string) || 0 : 0),
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'forwarder',
    headerName: translate('backlog.firmQuoteBulkForm.columns.forwarder', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.forwarder || '',
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'container_type',
    headerName: translate('backlog.firmQuoteBulkForm.columns.containerType', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.container_type || '',
    valueOptions: Object.values(ContainerTypeEnum) as string[],
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'type_of_goods',
    headerName: translate('backlog.firmQuoteBulkForm.columns.typeOfGoods', { namespace: 'features' }),
    type: 'singleSelect',
    valueGetter: (_value, row) => row?.type_of_goods || '',
    valueOptions: ['FAK', 'PLASTIC', 'METAL', 'OTHER'],
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'quoted_on',
    headerName: translate('backlog.firmQuoteBulkForm.columns.quotedOn', { namespace: 'features' }),
    type: 'date',
    valueGetter: (_value, row) => (row?.quoted_on ? new Date(row.quoted_on as string) : null),
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'expires_on',
    headerName: translate('backlog.firmQuoteBulkForm.columns.expiresOn', { namespace: 'features' }),
    type: 'date',
    valueGetter: (_value, row) => (row?.expires_on ? new Date(row.expires_on as string) : null),
  },
  {
    columnSize: 'medium',
    editable: true,
    field: 'estimated_vessel_departure_date',
    headerName: translate('backlog.firmQuoteBulkForm.columns.estimatedDeparture', { namespace: 'features' }),
    type: 'date',
    valueGetter: (_value, row) =>
      row?.estimated_vessel_departure_date ? new Date(row.estimated_vessel_departure_date as string) : null,
  },
  {
    columnSize: 'xLarge',
    editable: true,
    field: 'notes',
    headerName: translate('backlog.firmQuoteBulkForm.columns.notes', { namespace: 'features' }),
    valueGetter: (_value, row) => row?.notes || '',
  },
];
